import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --font-family-pretendard-jp: 'Pretendard JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    --font-family-base: var(--font-family-pretendard-jp);
    --Label-Normal: #171719;
    --Label-Alternative: rgba(55, 56, 60, 0.61);
    --Label-Neutral: rgba(46, 47, 51, 0.88);
    --Label-Assistive: rgba(55, 56, 60, 0.28);
    --Background-Normal-Normal: #fff;
    --Fill-Normal: rgba(112, 115, 124, 0.08);
    --Line-Normal-Normal: rgba(112, 115, 124, 0.22);
    --Line-Normal-Alternative: rgba(112, 115, 124, 0.08);
    --Line-Normal-Neutral: rgba(112, 115, 124, 0.16);
    --Static-White: #fff;
  }

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    pointer-events: auto;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
  }

  img {
    -webkit-user-drag: none !important;
    -khtml-user-drag: none !important;
    -moz-user-drag: none !important;
    -o-user-drag: none !important;
    user-drag: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
    pointer-events: none !important;
    -webkit-touch-callout: none !important;
    -webkit-tap-highlight-color: transparent !important;
  }

  img, video, audio, canvas, svg {
    -webkit-user-drag: none !important;
    -khtml-user-drag: none !important;
    -moz-user-drag: none !important;
    -o-user-drag: none !important;
    user-drag: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
    pointer-events: none !important;
  }

  p, span, h1, h2, h3, h4, h5, h6, text, input, textarea, label {
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
    user-select: text !important;
    pointer-events: auto !important;
  }

  button, a, [role="button"], [tabindex] {
    pointer-events: auto !important;
  }

  html {
    overflow-x: hidden;
    scroll-behavior: auto;
  }

  html, body {
    width: 100%;
    overflow-x: hidden;
    scroll-behavior: auto;
  }

  body {
    line-height: 1.5;
    min-width: 320px;
    font-family: var(--font-family-base, 'Pretendard JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    overflow-x: hidden;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
    font-family: var(--font-family-base, inherit);
  }

  input, textarea {
    font-family: var(--font-family-base, inherit);
  }

  .pretendard-jp {
    font-family: var(--font-family-base);
  }

  .tbc-content {
    user-select: auto !important;
  }

  .tbc-content img {
    max-width: 50% !important;
    height: auto;
    display: block !important;
  }

  .tbc-content pre {
    position: relative;
    background: var(--Fill-Weak, rgba(112, 115, 124, 0.04));
    border: 1px solid var(--Line-Normal-Alternative, rgba(112, 115, 124, 0.08));
    border-radius: 8px;
    padding: 12px 12px 12px 44px;
    overflow: auto;
    counter-reset: line;
  }

  .tbc-content pre code {
    display: block;
    font-family: 'JetBrains Mono', 'Menlo', 'Monaco', 'Consolas', monospace;
    font-size: 13px;
    color: var(--Label-Normal, #171719);
    white-space: pre;
  }

  .tbc-content pre code span.tbc-line {
    display: block;
    counter-increment: line;
  }

  .tbc-content pre code span.tbc-line::before {
    content: counter(line);
    position: absolute;
    left: 12px;
    min-width: 24px;
    text-align: right;
    color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  }

  .tbc-content pre code .tbc-token-tag {
    color: #9c27b0;
  }

  .tbc-content pre code .tbc-token-attr {
    color: #3f51b5;
  }

  .tbc-content pre code .tbc-token-string {
    color: #2e7d32;
  }

  .tbc-content pre code .tbc-token-comment {
    color: #9e9e9e;
    font-style: italic;
  }

  .tbc-content ul:last-of-type {
    margin-top: 12px;
  }

  ul.tbc-attachments {
    margin-top: 12px;
    padding: 12px;
    background: var(--Fill-Normal);
    border: 1px solid var(--Line-Normal-Normal);
    border-radius: 8px;
  }

  ul.tbc-attachments li.tbc-attachment {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    font-size: 13px;
    margin-bottom: 8px;
  }

  ul.tbc-attachments li.tbc-attachment:last-child {
    margin-bottom: 0;
  }

  ul.tbc-attachments a.tbc-attachment__link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    color: var(--Label-Normal);
  }

  span.tbc-attachment__thumb-wrap {
    display: flex;
    align-items: center;
  }

  ul.tbc-attachments img.tbc-attachment__thumb {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  ul.tbc-attachments .tbc-attachment__name {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .tbc-editor ul.tbc-attachments .tbc-attachment__delete {
    margin-left: auto;
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50% !important;
    color: rgba(55, 56, 60, 0.61);
    background: transparent;
    border: 1px solid rgba(55, 56, 60, 0.28);
    text-decoration: none;
    user-select: none;
    font-size: 0;
    transition: all 0.18s ease;
  }

  ul.tbc-attachments .tbc-attachment__delete {
    display: none;
  }

  .tbc-editor ul.tbc-attachments .tbc-attachment__delete:hover {
    color: #ff4444;
    border-color: #ff4444;
    background: rgba(255, 68, 68, 0.08);
  }

  .tbc-editor ul.tbc-attachments .tbc-attachment__delete:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 68, 68, 0.25);
  }

  .favicon-fallback {
    display: inline-block;
    width: 16px;
    height: 16px;
    position: relative;
    border-radius: 3px;
    background: #007bff;
  }

  .favicon-fallback::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
    transform: translate(-50%, -50%);
  }

  .favicon-loading {
    animation: faviconPulse 1.5s ease-in-out infinite;
  }

  @keyframes faviconPulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }
`;

export default GlobalStyle;
